import axios from './index'

export default{
    // 查询OA通知公告列表(分页)
    queryNoticeList(params) {
        return axios.post('/Product/GetList', params)
    },
    // 获取通知公告列表
    getNoticeList(params) {
        return axios.post('/Product/GetMore', params)
    },
    // 获取通知公告详情
    getNoticeInfo(noticeId) {
        return axios.get(`/Product/GetInfo?id=${noticeId}`)
    },
    // 获取分类
    getNewCategory() {
        return axios.get(`/Product/GetDic`)
    }

    
}


// WEBPACK FOOTER //
// ./src/api/api.js